import {Dispatch, SetStateAction} from 'react'
import {AxiosError, AxiosInstance} from 'axios'
import _ from 'lodash'
import {IMessage} from 'Src/utilities/useAxios'

interface SaveTradeParams {
  a2zApi: AxiosInstance
  leadId: number
  TradeVehicleMetadata: {yearId: number; makeName: string; modelName: string; originalMSRP: number}
  TradeVehicleCondition: string
  TradeVehicleMileage: number
  TradeVehicleValue: number
  estimatedPayoffAmount: number
  setMessages: Dispatch<SetStateAction<IMessage[]>>
}

export const saveTrade = ({
  a2zApi,
  leadId,
  TradeVehicleMetadata,
  TradeVehicleCondition,
  TradeVehicleMileage,
  TradeVehicleValue,
  estimatedPayoffAmount,
  setMessages,
}: SaveTradeParams) => {
  // Destructure vehicle info here
  const vehicle = (({yearId, makeName, modelName, originalMSRP}) => ({
    yearId,
    makeName,
    modelName,
    originalMSRP,
  }))(TradeVehicleMetadata)

  try {
    // need the separate variable so we can catch and handle errors
    const response = a2zApi.post(
      `/digital-retail/customers/leads/${leadId}/vehicles/trades?include=lead`,
      {
        data: {
          attributes: {
            vehicle,
            // Since "very good" is hyphenated on the backend, we're gonna transform it manually to save
            // work on matching a condition up while not breaking the front end, which seems to require
            // the single-word, all lowercase styling at the moment
            trade_condition:
              TradeVehicleCondition === 'verygood' ? 'very-good' : TradeVehicleCondition,
            mileage: TradeVehicleMileage,
            value: TradeVehicleValue,
            payoff: estimatedPayoffAmount || 0,
          },
        },
      }
    )

    return response
  } catch (e) {
    let message = 'The following errors occurred:<br/><ul style="list-style: unset">'
    const title = 'Error Saving Trade'

    if (e instanceof AxiosError) {
      if (!e.response?.data?.errors) {
        // generic error message
        setMessages([
          {
            title,
            description: 'There was an error while trying to save the trade.',
            type: 'error',
          },
        ])

        return
      }

      const {detail} = e.response?.data?.errors?.[0] || {}
      Object.keys(detail).forEach((key) => {
        Object.values(detail[key]).forEach((value) => {
          console.log(value)
          const values = (value as string).split('.')

          message += `<li>${_.capitalize(values[values.length - 2])}</li>`
        })
      })

      message += `</ul>`
      setMessages([
        {
          title,
          description: message,
          type: 'error',
        },
      ])

      return e.response?.data
    }
  }
}
